export default "__VITE_ASSET__CMGlN82B__"